import httpClient from "./httpClient";

export function listAuditLogs() {
  return httpClient.get("/audit-logs").then((res) => res.data.data);
}

export function getAuditLog(auditId) {
  return httpClient.get(`/audit-logs/${auditId}`).then((res) => res.data.data);
}

export function getAuditHistory(entityName, entityId) {
  return httpClient.get(`/audit-logs/${entityName}/${entityId}/history`).then((res) => res.data.data);
}
